'use client';

import { Error } from '../components/error';
export default Error;